/**
 * @generated SignedSource<<d9adad55e36f5164f9b82f9bc2c20551>>
 * @relayHash 8a6a3d5a2b9486afff07f1a4164dac33
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0588a5a73b3045ab908a63852c6241e0fd7b8aa2d474b73a7143e5228193af90

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useCreateProjectCheckPermissionsQuery$variables = {
  cloudId: string;
};
export type useCreateProjectCheckPermissionsQuery$data = {
  readonly jira: {
    readonly canCreateCompanyManagedProject: boolean | null | undefined;
    readonly canCreateProject: boolean | null | undefined;
    readonly canCreateTeamManagedProject: boolean | null | undefined;
  } | null | undefined;
};
export type useCreateProjectCheckPermissionsQuery = {
  response: useCreateProjectCheckPermissionsQuery$data;
  variables: useCreateProjectCheckPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "alias": "canCreateProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      },
      {
        "alias": "canCreateTeamManagedProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_TEAM_MANAGED_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      },
      {
        "alias": "canCreateCompanyManagedProject",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "type",
            "value": "CREATE_COMPANY_MANAGED_PROJECT"
          }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreateProjectCheckPermissionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateProjectCheckPermissionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "0588a5a73b3045ab908a63852c6241e0fd7b8aa2d474b73a7143e5228193af90",
    "metadata": {},
    "name": "useCreateProjectCheckPermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "26cfc52f838e715229730ac022252212";

export default node;
